import { render, staticRenderFns } from "./DrawerFooter.vue?vue&type=template&id=0f6c3808&scoped=true&"
import script from "./DrawerFooter.vue?vue&type=script&lang=js&"
export * from "./DrawerFooter.vue?vue&type=script&lang=js&"
import style0 from "./DrawerFooter.vue?vue&type=style&index=0&id=0f6c3808&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c3808",
  null
  
)

export default component.exports